module.exports = __webpack_public_path__ + "files/be5212a31aa5a11d5daa490c5745a62f.svg";